import { Check, Play } from "lucide-react";
import { Phone, ProductScreen } from "../components/ProductScreen.js";

export function Hero() {
  return (
    <section id="top" className="hero">
      <div className="page hero__inner">
        <div className="hero__copy">
          <p className="overline">
            <span className="overline__rule" aria-hidden="true" />
            Giving, brought together
          </p>
          <h1 className="hero__headline">
            Turn a room full of <em>generosity</em> into real impact.
          </h1>
          <p className="hero__sub">
            Make giving easy. Bring your community closer. See every moment of generosity come
            together with GiveHere.
          </p>
          <div className="cta-row">
            <a className="btn btn--primary" href="#demo">
              Book a demo
            </a>
            <a className="btn btn--secondary" href="#how-it-works">
              <span className="btn--secondary__ring">
                <Play size={13} fill="currentColor" />
              </span>
              See how it works
            </a>
          </div>
          <div className="hero__footnote">
            <span>Made for communities.</span>
            <span>Built around giving.</span>
          </div>
        </div>
        <div
          className="hero__visual"
          role="img"
          aria-label="GiveHere donor app beside the organizer dashboard: easy giving for donors and a connected view for organizers."
        >
          {/* GH-897 (owner, 2026-10-06): the dashboard/phone composition below is built from fixed
              pixel sizes and offsets (280px dashboard, 170px phone, etc.) that read correctly at
              its 420x420 design size but never shrank on a narrow viewport, so the whole mockup
              grew to fill proportionally more of the frame on mobile than on desktop — it looked
              zoomed in relative to its card even though nothing was actually overflowing. Wrapping
              it in one stage and scaling the stage as a unit (see .hero__visual-stage in hero.css)
              keeps every pixel value below exactly as authored; only the narrow-viewport media
              queries change. */}
          <div className="hero__visual-stage">
            <div className="hero__halo" aria-hidden="true" />
            <div className="hero__dashboard">
              <div className="browser-bar">
                <span className="browser-bar__dot" />
                <span className="browser-bar__dot" />
                <span className="browser-bar__dot" />
                <p className="browser-bar__title">GiveHere · Organizer workspace</p>
              </div>
              <div className="hero__dashboard-screen">
                <ProductScreen screen="overview" eager />
              </div>
            </div>
            <Phone className="hero__phone" screen="giving" />
            <div className="hero__gift-note">
              <span className="hero__gift-icon">
                <Check size={18} />
              </span>
              <div>
                <b>A little easier to give.</b>
                <span>A little more possible.</span>
              </div>
            </div>
            <p className="hero__caption">Product preview · illustrative event data</p>
          </div>
        </div>
      </div>
    </section>
  );
}
